export const PaymentCancelPage = () => {
  return (
    <div style={{ padding: "20px", color: "orange" }}>
      <h1>결제가 취소되었습니다</h1>
      <p>결제 과정이 취소되었습니다.</p>
      <a href="/home">홈으로 돌아가기</a>
    </div>
  );
};
